module.exports = __webpack_public_path__ + "img/anhembi.01d5cdbb.png";